module.exports = __webpack_public_path__ + "static/kdb-banner-3@2x-ccfcfb368f526cd9016d0190717f07e7.png";